/** Production customer portal hosts: tenant.myservicetitan.com */
const PRODUCTION_HOST = /\.myservicetitan\.com$/;

export function isDatadogRumEnabled(hostname: string): boolean {
    return PRODUCTION_HOST.test(hostname);
}
